import React, {memo} from 'react';
import Loader from "../assets/icons/Loader";

interface ButtonType {
    name: string,
    className?: string,
    relativeClassName?: string,
    withProgressBar?: boolean,
    isInProgress?: boolean,
    onClick?: () => void,
    type?: 'button' | 'submit' | 'reset',
}

const Button = React.forwardRef(({name, className, relativeClassName, onClick, withProgressBar = false, isInProgress = false, type = 'button'}:ButtonType) => {

    const onLocalClick = () => {
        if (onClick)
            onClick();
    }

    return (
        <div className={`relative text-center ${relativeClassName ?? 'my-2'}`}>
            <button type={type} disabled={withProgressBar && isInProgress} onClick={onLocalClick} className={`${className?? ''} rounded-2xl px-8 py-2`}>{withProgressBar && isInProgress ? <Loader/> : name}</button>
        </div>
    );

});
Button.displayName = 'Button';

export default memo(Button);
